// Giriş isteği 428 + `code: PUZZLE_REQUIRED` dönerse yapboz gösterilir
// (backend modules/security/loginPuzzle.ts `puzzleRequiredBody`).
export const PUZZLE_REQUIRED_CODE = "PUZZLE_REQUIRED";

export function isPuzzleRequiredError(error: unknown): boolean {
  const res = (error as { response?: { status?: number; data?: { code?: unknown } } } | null)?.response;
  return res?.status === 428 && res.data?.code === PUZZLE_REQUIRED_CODE;
}
